import useSWR from "swr"
import { InboundOrderApi } from "../../../apis"

export function useInboundExceptionsQuery(id: string | null | undefined) {
  return useSWR(
    id ? ["inbound-exceptions", id] : null,
    async () => InboundOrderApi.listExceptions(id as string),
    { revalidateOnFocus: false },
  )
}
